import styled from '@emotion/styled';

/** A card UI element that involves a white background with grey borders and rounded corners */
export const Card = styled.div`
  padding: ${({ theme }) => theme.spacing(32)};
  border-radius: ${({ theme }) => theme.spacing(8)};
  border: 2px solid ${({ theme }) => theme.palette.gray[300]};
  background-color: ${({ theme }) => 'var(--cds-color-white-0)'};
  margin-bottom: ${({ theme }) => theme.spacing(32)};

  ${({ theme }) => theme.breakpoints.down('xs')} {
    max-width: 100%;
    padding: ${({ theme }) => theme.spacing(24)};
    border-left: none;
    border-right: none;
    border-radius: 0;
  }
`;
